import { render, staticRenderFns } from "./dashboard-graph.vue?vue&type=template&id=32c06b3e&scoped=true&"
import script from "./dashboard-graph.vue?vue&type=script&lang=js&"
export * from "./dashboard-graph.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-graph.vue?vue&type=style&index=0&id=32c06b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c06b3e",
  null
  
)

export default component.exports